import $ from 'jquery';

import { showPopup, FixedPositionLocation, PositioningMethod } from '@bingads-webui/automatic-positioning-popover';
import { DeterministicViewForBackBoneView } from '@bingads-webui/deterministic-wrapper-view';

import { ScheduledImportPopup } from './scheduled-import-popup';

export function showScheduledImportPopup(e, account, container) {
  const i18n = window.require('@bingads-webui/i18n-amd-loader!campaignui/feature/accounts-summary');
  const i18nGlobal = window.require('component/i18n/loader!legacy/global');
  const importTaskItemSchema = window.require('$/schema!campaign/ImportTaskItem');

  const importStatusColumnTmpl = window.require('campaignui/feature/bingadsgrid/template/status-column');
  const importSchedNameTmpl = window.require('campaignui/feature/scheduled-import/template/import-schedule-name');
  const constants = window.require('campaignui/feature/scheduled-import/view/import-schedule-constants');
  const { importFreqColDataToTemplate } = window.require('campaignui/feature/scheduled-import/view/shared-column-configs/import-freq-col');
  const edm = window.require('component/edm-campaign/index').default;
  const jsdataCampaign = window.require('component/js-data-campaign/index');

  const scheduledImportPopup = new ScheduledImportPopup({
    aid: account.Id,
    deps: {
      i18n,
      i18nGlobal,
      importTaskItemSchema,
      importStatusColumnTmpl,
      importSchedNameTmpl,
      constants,
      importFreqColDataToTemplate,
      edm,
      jsdataCampaign,
    },
  });
  const contentView = new DeterministicViewForBackBoneView({ view: scheduledImportPopup });

  showPopup({
    contentView,
    i18n,
    container,
    positioningOptions: {
      location: FixedPositionLocation.bottomLeft,
    },
    positioningMethod: PositioningMethod.fixed,
    anchor: $(e.target),
  });
}
